/**
 * Created by sdielmann on 30.11.2017.
 */
import { Component, EventEmitter, forwardRef, HostBinding, Input, Output } from '@angular/core';


let nextUniqueId = 0;

export abstract class MuiAccordionProvider {
  abstract id: string;
  abstract expanded: boolean;
  abstract contentUnmounted: boolean;
  abstract expandedStateChanged: EventEmitter<boolean>;

  abstract toggleExpandedState(): void;
}

@Component({
  selector: 'mui-accordion',
  styles: [
    `:host {
      display: block;
    }`
  ],
  template: '<ng-content></ng-content>',
  providers: [
    {
      provide: MuiAccordionProvider,
      useExisting: forwardRef(() => MuiAccordion)
    }
  ]
})
export class MuiAccordion extends MuiAccordionProvider {
  @Input()
  @HostBinding('attr.id')
  id: string;

  @Output() toggle = new EventEmitter<boolean>();
  @Output() expandedStateChanged = new EventEmitter<boolean>();

  @Input()
  @HostBinding('class.expanded')
  @HostBinding('attr.aria-expanded')
  get expanded(): boolean { return this._expanded; }

  set expanded(val: boolean) {
    this._expanded = val;
    this.expandedStateChanged.emit(this._expanded);
  }

  @Input() contentUnmounted = false;

  protected _expanded = false;
  protected _uid = `mui-accordion-${nextUniqueId++}`;

  constructor() {
    super();
    this.id = this._uid;
  }

  toggleExpandedState(): void {
    const newState = !this._expanded;
    this.toggle.emit(newState);
    this.expanded = newState;
  }
}
